module.exports = __webpack_public_path__ + "img/top-0-5.bec7e7eb.jpg";